import React from 'react';
import { CheckCircle, TrendingUp, Globe, Handshake } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function ExecutiveSummary() {
  const {
    t
  } = useLanguage();
  const highlights = [{
    icon: TrendingUp,
    label: t.executiveSummary.commitment.highlights.quality
  }, {
    icon: Globe,
    label: t.executiveSummary.commitment.highlights.standards
  }, {
    icon: Handshake,
    label: t.executiveSummary.commitment.highlights.practices
  }];
  return <section id="about" className="w-full py-16 md:py-24 bg-white" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-48">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-49">
            {t.executiveSummary.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-50">
            {t.executiveSummary.title}
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-51">
          {/* Left Content */}
          <div data-id="element-52">
            <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-53">
              {t.executiveSummary.paragraph1}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-54">
              {t.executiveSummary.paragraph2}
            </p>

            {/* Key Points */}
            <div className="space-y-4" data-id="element-55">
              {t.executiveSummary.keyPoints.map((point, index) => <div key={index} className="flex items-start gap-3" data-id="element-56">
                  <CheckCircle className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-57" />
                  <span className="text-gray-700" data-id="element-58">{point}</span>
                </div>)}
            </div>
          </div>

          {/* Right Content - Card */}
          <div className="relative" data-id="element-59">
            <div className="bg-gradient-to-br from-emerald-700 to-emerald-800 rounded-3xl p-8 md:p-10 text-white shadow-xl" data-id="element-60">
              <h3 className="text-2xl font-bold mb-6" data-id="element-61">
                {t.executiveSummary.commitment.title}
              </h3>
              <p className="text-emerald-100 mb-8 leading-relaxed" data-id="element-62">
                {t.executiveSummary.commitment.description}
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-63">
                {highlights.map(item => <div key={item.label} className="text-center p-4 bg-white/10 rounded-xl backdrop-blur-sm" data-id="element-64">
                    <item.icon className="w-8 h-8 mx-auto mb-2 text-emerald-200" data-id="element-65" />
                    <span className="text-sm font-medium text-emerald-100" data-id="element-66">
                      {item.label}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -z-10 -bottom-4 -right-4 w-full h-full bg-emerald-200 rounded-3xl" data-id="element-67" />
          </div>
        </div>
      </div>
    </section>;
}